export default (theme) => ({
  mainBody: {
    width: "100%",
    marginTop: 24,
    padding: 25,
  },
  mainPaper: {
    padding: 25,
  },
  bold: {
    fontWeight: 500,
  },
  errorMessage: {
    margin: 20,
    padding: 20,
    backgroundColor: "#fff",
    border: "1px solid red",
  },
  tableLink: {
    color: "#9575cd",
  },
  clickableRow: {
    cursor: "pointer",
  },
  tableRoot: {
    width: "100%",
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
    "& td": {
      fontSize: 16,
      fontWeight: "400",
      lineHeight: "24px",
    },
  },
  toolbarRow: {
    backgroundColor: "#e9e9e9",
  },
  messagesContainer: {
    paddingTop: 25,
    paddingBottom: 25,
  },
  parentMessage: {
    textAlign: "left",
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 15,
  },
  clinicianMessage: {
    textAlign: "left",
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: 15,
  },
  messageBlock: {
    display: "block",
    width: "40%",
  },
  messageBlue: {
    display: "block",
    padding: 12,
    backgroundColor: "#2196f3",
    color: "#fff",
    borderRadius: 6,
  },
  messageGray: {
    display: "block",
    padding: 12,
    backgroundColor: "#999999",
    color: "#fff",
    borderRadius: 6,
  },
  messageTime: {
    width: "40%",
    display: "block",
    marginTop: 5,
    fontSize: ".7rem",
    color: "#666",
  },
  messageSender: {
    width: "fit-content",
    display: "block",
    marginBottom: 5,
    fontSize: ".7rem",
    "&:hover": {
      cursor: "pointer",
      fontWeight: "bold",
    },
  },
  smallText: {
    fontSize: ".8rem",
    color: "#666",
  },
  searchContainer: {
    width: 340,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 10,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "30px",
    width: "100%",
  },
  headerColumnDirection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "30px",
    width: "100%",
  },
  metricBlock: {},
  chip: {
    margin: "0.5px",
  },
  inputs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: "5px",
    zIndex: 5,
  },
  appBar: {
    zIndex: 0,
  },
  noVideoScheduledRow: {
    "& td": {
      color: "#ff0000",
    },
  },
});
